{
  "R": [0, 142, 227, 255],
  "G": [0, 85, 170, 255],
  "B": [0, 14, 76, 255],
  "A": [0, 42, 84, 128],
  "I": [0, 85, 170, 255]
}
